const REFRESH_END_POINT = process.env.REACT_APP_REFRESH_END_POINT;

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
  refreshSubscribers.push(callback);
}

function onTokenRefreshed(newToken) {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
}

function getAuthInfo() {
  const userinfo = sessionStorage.getItem('userinfo');
  return userinfo ? JSON.parse(userinfo) : null;
}

function setAuthInfo(data) {
  sessionStorage.setItem('userinfo', JSON.stringify(data));
}

function clearAuthInfo() {
  sessionStorage.removeItem('userinfo');
}

function redirectToLogin() {
  clearAuthInfo();
  // Save current URL to return after login
  const currentPath = window.location.pathname + window.location.search;
  if (currentPath !== '/login') {
    sessionStorage.setItem('returnUrl', currentPath);
  }
  window.open('/login', '_self', 'noopener,noreferrer');
}

function getReturnUrl() {
  const returnUrl = sessionStorage.getItem('returnUrl');
  sessionStorage.removeItem('returnUrl');
  return returnUrl;
}

async function refreshToken() {
  const userinfo = getAuthInfo();
  if (!userinfo?.refreshToken) {
    throw new Error('No refresh token available');
  }

  const response = await fetch(REFRESH_END_POINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken: userinfo.refreshToken }),
  });

  if (!response.ok) {
    throw new Error('Failed to refresh token');
  }

  const data = await response.json();
  setAuthInfo({
    id: data.id,
    token: data.token,
    refreshToken: data.refreshToken,
  });

  return data.token;
}

async function authFetch(url, options = {}) {
  const userinfo = getAuthInfo();

  if (!userinfo?.token) {
    redirectToLogin();
    return Promise.reject(new Error('Not authenticated'));
  }

  const authOptions = {
    ...options,
    headers: {
      ...options.headers,
      Authorization: 'Bearer ' + userinfo.token,
    },
  };

  let response = await fetch(url, authOptions);

  if (response.status === 401) {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((newToken) => {
          authOptions.headers.Authorization = 'Bearer ' + newToken;
          fetch(url, authOptions).then(resolve).catch(reject);
        });
      });
    }

    isRefreshing = true;

    try {
      const newToken = await refreshToken();
      isRefreshing = false;
      onTokenRefreshed(newToken);

      authOptions.headers.Authorization = 'Bearer ' + newToken;
      response = await fetch(url, authOptions);
    } catch (error) {
      isRefreshing = false;
      redirectToLogin();
      return Promise.reject(error);
    }
  }

  return response;
}

export { authFetch, getAuthInfo, setAuthInfo, clearAuthInfo, redirectToLogin, getReturnUrl };
